/**
 * COLUMN SELECTOR MODAL
 * Modal pour sélectionner/masquer les colonnes du tableau
 */

import { useState } from 'react';
import { Checkbox } from '../ui/checkbox';
import { Modal, ModalFooter } from '../ui/modal';

interface ColumnOption {
  id: string;
  label: string;
  visible: boolean;
}

interface ColumnSelectorModalProps {
  isOpen: boolean;
  onClose: () => void;
  columns: ColumnOption[];
  onApply: (columns: ColumnOption[]) => void;
}

export function ColumnSelectorModal({
  isOpen,
  onClose,
  columns,
  onApply,
}: ColumnSelectorModalProps) {
  const [localColumns, setLocalColumns] = useState(columns);

  const handleToggle = (columnId: string) => {
    setLocalColumns((prev) =>
      prev.map((col) => (col.id === columnId ? { ...col, visible: !col.visible } : col))
    );
  };

  const handleApply = () => {
    onApply(localColumns);
    onClose();
  };

  const handleReset = () => {
    setLocalColumns(columns.map((col) => ({ ...col, visible: true })));
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Colonnes visibles"
      footer={
        <div className="flex items-center justify-between w-full">
          <button
            onClick={handleReset}
            className="text-sm text-zinc-500 hover:text-zinc-900 transition-colors"
          >
            Tout afficher
          </button>
          <ModalFooter onCancel={onClose} onSubmit={handleApply} submitLabel="Appliquer" />
        </div>
      }
    >
      <div className="space-y-2 max-h-96 overflow-y-auto">
        {localColumns.map((column) => (
          <div
            key={column.id}
            className="hover:bg-zinc-50 px-2 py-1.5 rounded-md transition-colors"
          >
            <Checkbox
              checked={column.visible}
              onChange={() => handleToggle(column.id)}
              label={column.label}
            />
          </div>
        ))}
      </div>
    </Modal>
  );
}
